import { memo, useState, useRef, useLayoutEffect } from 'react'
import { useClickOutside } from 'builder/hooks/useClickOutside'
import { useEscapeHandler } from 'builder/hooks/useEscapeHandler'
import { reflow } from 'builder/utils/reflow'
import { ColorPickerProps } from 'builder/components/ColorPicker'
import { PropTypes, StyledColorPicker } from './styles'

type Props = {
  onClose: () => void
} & PropTypes &
  ColorPickerProps

// Extends `ColorPicker` with the displaying transition,
// and adds click-outside behavior
export const ColorPickerControl = memo(({ onClose, ...rest }: Props) => {
  const [isVisible, setVisible] = useState(false)
  const container = useRef<HTMLDivElement>(null)

  useLayoutEffect(() => {
    if (!container.current) return
    reflow(container.current)
    setVisible(true)
  }, [])

  useClickOutside(container, onClose)
  useEscapeHandler(onClose)

  return <StyledColorPicker ref={container} isVisible={isVisible} {...rest} />
})
